import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-500)] focus:ring-offset-2 [&_svg]:size-3 [&_svg]:shrink-0 gap-1",
  {
    variants: {
      variant: {
        default: "border-transparent bg-[var(--color-primary-500)] text-white",
        secondary:
          "border-transparent bg-[var(--color-grey-100)] text-[var(--color-text-primary)]",
        destructive: "border-transparent bg-[var(--color-red-500)] text-white",
        outline:
          "text-[var(--color-text-primary)] border-[var(--color-border-default)]",
        success:
          "border-transparent bg-[var(--color-green-100)] text-[var(--color-green-700)]",
        warning:
          "border-transparent bg-[var(--color-orange-100)] text-[var(--color-orange-700)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  asChild?: boolean;
}

function Badge({ className, variant, asChild = false, ...props }: BadgeProps) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
